import { render, staticRenderFns } from "./Sentiments.vue?vue&type=template&id=682336fa&scoped=true"
import script from "./Sentiments.vue?vue&type=script&lang=js"
export * from "./Sentiments.vue?vue&type=script&lang=js"
import style0 from "./Sentiments.vue?vue&type=style&index=0&id=682336fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682336fa",
  null
  
)

export default component.exports